import { RouteConfig, NavigationGuard } from 'vue-router'
import { AppUtil, VueUtil } from 'kuaidong-lib'

const CompetitionHome = () => import('../../views/fitscreen/home/CompetitionHome.vue')

/**
 * fitscreen 路由守卫 - 设置 iPad 体锻屏 rem 基准
 */
const fitscreenBeforeEnter: NavigationGuard = (_to, _from, next) => {
  // VueUtil.setRem(VueUtil.setRemByMainEleId.bind(VueUtil), 'app', 1366, 12)
  next()
}

const RankDetail = () => import('../../views/fitscreen/rank/RankDetail.vue')
const StudentSelect = () => import('../../views/fitscreen/profile-setup/StudentSelect.vue')
const ManageConfirm = () => import('../../views/fitscreen/profile-setup/ManageConfirm.vue')
const SetupFinished = () => import('../../views/fitscreen/profile-setup/SetupFinished.vue')
const StudentBind = () => import('../../views/fitscreen/profile-setup/StudentBind.vue')
const SetupEnter = () => import('../../views/fitscreen/profile-setup/SetupEnter.vue')
const ScanLogin = () => import('../../views/fitscreen/login/ScanLogin.vue')

export const competitionHomeRoute: RouteConfig = {
  path: '/fitscreen/competition-home',
  name: 'fitscreen_competition_home',
  component: CompetitionHome,
  props: (route) => ({ ...route.query }),
  meta: {
    // title: '比赛首页',
    title: ' ​', // 有个不可见的空格，避免 app 显示标题
  },
  beforeEnter: fitscreenBeforeEnter,
}

export const studentSelectRoute: RouteConfig = {
  path: '/fitscreen/profile-setup/student-select',
  name: 'fitscreen_profile_setup_student_select',
  component: StudentSelect,
  props: (route) => ({ ...route.query }),
  meta: {
    // title: '学生选择',
    title: ' ​',
    keepAlive: true,
  },
  beforeEnter: fitscreenBeforeEnter,
}

export const rankDetailRoute: RouteConfig = {
  path: '/fitscreen/rank/detail',
  name: 'fitscreen_rank_detail',
  component: RankDetail,
  props: (route) => ({ ...route.query }),
  meta: {
    title: ' ​',
  },
}

export const manageConfirmRoute: RouteConfig = {
  path: '/fitscreen/profile-setup/manage-confirm',
  name: 'fitscreen_profile_setup_manage_confirm',
  component: ManageConfirm,
  props: (route) => ({ ...route.query }),
  meta: {
    // title: '管理员确认',
    title: ' ​',
  },
  beforeEnter: fitscreenBeforeEnter,
}

export const setupFinishedRoute: RouteConfig = {
  path: '/fitscreen/profile-setup/setup-finished',
  name: 'fitscreen_profile_setup_finished',
  component: SetupFinished,
  props: (route) => ({ ...route.query }),
  meta: {
    title: ' ​',
  },
  beforeEnter: fitscreenBeforeEnter,
}

export const studentBindRoute: RouteConfig = {
  path: '/fitscreen/profile-setup/student-bind',
  name: 'fitscreen_profile_setup_student_bind',
  component: StudentBind,
  props: (route) => ({ ...route.query }),
  meta: {
    title: ' ​',
  },
  beforeEnter: fitscreenBeforeEnter,
}

export const scanLoginRoute: RouteConfig = {
  path: '/fitscreen/login/scan',
  name: 'fitscreen_login_scan',
  component: ScanLogin,
  props: (route) => ({ ...route.query }),
  meta: {
    title: ' ​',
  },
  beforeEnter: fitscreenBeforeEnter,
}

export const setupEnterRoute: RouteConfig = {
  path: '/fitscreen/profile-setup/setup-enter',
  name: 'fitscreen_profile_setup_enter',
  component: SetupEnter,
  props: (route) => ({ ...route.query }),
  meta: {
    title: ' ​',
  },
  beforeEnter: fitscreenBeforeEnter,
}

export default [
  competitionHomeRoute,
  studentSelectRoute,
  rankDetailRoute,
  manageConfirmRoute,
  setupFinishedRoute,
  studentBindRoute,
  scanLoginRoute,
  setupEnterRoute,
]
